export class BookSortType{
    constructor(){}

    static readonly Normal = 1;
    static readonly Date = 2;
}